import { Avatar, AvatarProps, Tooltip } from '@mantine/core';
import React from 'react';

import { useSeedRandomColor } from '../hooks';

interface NameAbbreviationAvatarProps extends AvatarProps {
  name: string;
  withToolTip?: boolean;
}

export function NameAbbreviationAvatar({
  withToolTip = true,
  name,
  color,
  ...avatarProps
}: NameAbbreviationAvatarProps) {
  const randomColor = useSeedRandomColor(name);
  const abbreviation = getNameAbbreviation(name);

  return (
    <Tooltip label={name} withArrow withinPortal disabled={!withToolTip}>
      <Avatar color={color || randomColor} {...avatarProps}>
        {abbreviation}
      </Avatar>
    </Tooltip>
  );
}

function getNameAbbreviation(name: string) {
  if (!name) return null;

  const nameWords = name.split(' ');

  const firstLetter = getFirstLetter(nameWords[0]).toUpperCase();

  if (nameWords.length === 1) {
    return firstLetter;
  }

  const lastWord = nameWords[nameWords.length - 1];
  const secondLetter = getFirstLetter(lastWord).toUpperCase();

  return `${firstLetter}${secondLetter}`;
}

function getFirstLetter(word: string) {
  if (!word) return '';

  const firstLetterIndex = word.search(/[a-z]/i);

  if (firstLetterIndex !== -1) {
    return word[firstLetterIndex];
  }

  return '';
}
